import React from 'react'
import { observer } from 'mobx-react'

import { Container } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';


interface Props {
    children: React.ReactNode,
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    centerContent?: boolean
    fixWhitespace?: boolean
    classNames?: string
    isDesktop?: boolean,
    scrollable: boolean,
    styles?: CSSProperties
}

const CustomContainer: React.FC<Props> = observer(({
    children,
    maxWidth,
    centerContent,
    fixWhitespace,
    classNames,
    isDesktop,
    scrollable,
    styles
}) => {


    return (
        <Container
            maxWidth={maxWidth ? maxWidth : 'lg'}
            disableGutters={true}
            // style={{fontSize: 0}}
            className={classNames}
            style={{
                display: 'flex',
                textAlign: centerContent ? 'center' : 'start',
                fontSize: fixWhitespace ? 0 : 'inherit',
                alignItems: 'center',
                overflowX: !isDesktop && scrollable ? 'scroll' : 'unset',
                ...styles
            }}
            children={children}
        />

    )
})

export default CustomContainer
